/* eslint-disable */

/*
 *  修订时间：2018-04-12
 *  使用方式：this.$lib.IsPC()
 * */

//
export default {
  /*
   * 获取url传值：普通值（解析带中文的值出现乱码）
   */
  getUrlParam: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  },
  /*
   * 获取url传值：中文值
   */
  getQueryString: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    var result = window.location.search.substr(1).match(reg)
    return result ? decodeURIComponent(result[2]) : null
  },
  /*
   * 检测是否为手机
   */
  IsPC: function () {
    var userAgentInfo = navigator.userAgent
    var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod"
    ]
    var flag = true
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
        break
      }
    }
    return flag
  },

  /*
   * 为手机用户添加手机版样式
   * @param id： 组件id
   * @param className： 需要添加的类名
   * */
  addC4M(id, className) {
    // console.log(className)
    let el = document.getElementById(id)
    if (!this.IsPC()) el.classList.add(className);
  },
  /*
   * 为mac添加特别样式
   * @param id： 组件id
   * @param className： 需要添加的类名
   * */
  addC4Mac(id, className) {
    // console.log(className)
    let el = document.getElementById(id)
    let H = document.body.clientHeight
    // console.log('浏览器高度：', document.body.clientHeight)
    if (this.IsPC() && H < 945) el.classList.add(className);
  },
  /*
   * 为iPad添加特别样式
   * @param id： 组件id
   * @param className： 需要添加的类名
   * */
  addC4iPad(id, className) {
    // console.log(className)
    let el = document.getElementById(id)
    let H = document.body.clientHeight
    // console.log('浏览器高度：', document.body.clientHeight)
    if (this.detectBrowser.iPad) el.classList.add(className);
  },
  /*
   * 设置关闭手机键盘
   * */
  toggleNext: function (next) { // next是将要focus的元素
    document.activeElement.blur()
    next.focus()
  },

  /*
   * 复制到剪贴板
   * */
  copyInput: function (ele, fn) {
    // let e=document.getElementById("copyLink");//对象是contents
    // e.select(); //选择对象
    // let tag=document.execCommand("Copy"); //执行浏览器复制命令

    var _inputText = document.querySelector(ele)
    // console.log(_inputText);
    if (document.body.createTextRange) {
      // console.log('ie');
      var sel = document.body.createTextRange()
      sel.moveToElementText(_text)
      //把表格中的内容移到TextRange中
      sel.select
      //全选TextRange中内容
      sel.execCommand("Copy")
      //复制成功回调
      fn && fn('success')
    } else {
      var currentFocus = document.activeElement
      _inputText.focus()
      _inputText.setSelectionRange(0, _inputText.value.length)
      document.execCommand('copy', true)
      currentFocus.focus()
      // console.log('copy over');
      //复制成功回调
      fn && fn('success')
    }
  },

  /*
   * 检测浏览器、手机类型
   * */
  detectBrowser: function () {
    var u = navigator.userAgent,
      app = navigator.appVersion
    return {
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') == -1, // 是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
      samsung: u.indexOf('GALAXY Tab') > -1, // 是否三星平板 （2018-01-15新增 未确定有效）
      qq: u.match(/\sQQ/i) == " qq" // 是否QQ
    }
  }(),
  /*
   * 检测浏览器语言
   * */
  language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  /*
   * 检测系统型号
   * */
  detectOS: function () {
    var sUserAgent = navigator.userAgent
    var isWin = (navigator.platform === "Win32") || (navigator.platform === "Windows")
    var isMac = (navigator.platform === "Mac68K") || (navigator.platform === "MacPPC") || (navigator.platform === "Macintosh") || (navigator.platform === "MacIntel")
    if (isMac) return "Mac"
    var isUnix = (navigator.platform === "X11") && !isWin && !isMac
    if (isUnix) return "Unix"
    var isLinux = (String(navigator.platform).indexOf("Linux") > -1)
    if (isLinux) return "Linux"
    if (isWin) {
      var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1
      if (isWin2K) return "Win2000"
      var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1
      if (isWinXP) return "WinXP"
      var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1
      if (isWin2003) return "Win2003"
      var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1
      if (isWinVista) return "WinVista"
      var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1
      if (isWin7) return "Win7"
      var isWin8 = sUserAgent.indexOf("Windows NT 8.0") > -1 || sUserAgent.indexOf("Windows 8") > -1
      if (isWin8) return "Win8"
      var isWin81 = sUserAgent.indexOf("Windows NT 8.1") > -1 || sUserAgent.indexOf("Windows 8.1") > -1
      if (isWin81) return "Win8.1"
      var isWin10 = sUserAgent.indexOf("Windows NT 10.0") > -1 || sUserAgent.indexOf("Windows 10") > -1
      if (isWin10) return "Win10"
      if (isWin) return "Win"
    }
    return "other"
  },
  /*
   * 设置Cookie
   * */
  setCookie: function (name, value, day) {
    var Days = day || 30
    var exp = new Date()
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString()
  },
  /*
   * 获取Cookie
   * */
  getCookie: function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
    if (arr = document.cookie.match(reg))
      return unescape(arr[2])
    else
      return null
  },
  /*
   * 删除Cookie
   * */
  delCookie: function (name) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = this.getCookie(name)
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()
  },
  /*
   * 监听页面滚动方向
   * */
  scrollCheck: function (fn) { // 一般性页面上下滚动检测（页面 > 窗口）
    var beforeScrollTop = document.body.scrollTop,
      fn = fn || function () {}
    window.addEventListener("scroll", function () {
      var afterScrollTop = document.body.scrollTop,
        delta = afterScrollTop - beforeScrollTop
      if (delta === 0) return false
      fn(delta > 0 ? "down" : "up")
      beforeScrollTop = afterScrollTop
    }, false)
  },
  /*
   * @功能
   *   监听鼠标滚轮方向
   * @param
   *   id: 目标区域的id
   *   RE: (relative error)相对误差，默认为50
   *   prevent: 阻止默认滚动事件
   *   cb: 回调
   * */
  wheelScrollCheck: function ({
    id,
    className,
    RE = 50,
    stop,
    prevent,
    cb
  }) { // PC整屏页面上下滚动检测（页面 <= 窗口）
    console.log('监听id：', id)
    var el = null
    if (id) {
      el = document.getElementById(id)
    } else if (className) {
      el = document.querySelector(className)
    }
    // pc监听滚动事件
    el.addEventListener("wheel", function (e) {
      // console.log('--------', e, '--------')
      let delta = e.deltaY
      if (delta === 0) return false
      // if(delta > RE) console.log('滚动距离：',delta);
      cb && cb(delta > RE ? "up" : delta < -RE ? "down" : "stay", delta) // windows滚轮一下是100单位，因此RE不能大于100个单位
        !stop && e.stopPropagation()
      prevent && e.preventDefault()
    }, false)
  },
  /*
   * @功能
   *   监听手指滑动方向
   * @param
   *   id: 目标区域的id
   *   RE: (relative error)相对误差，默认为50
   *   prevent: 阻止默认滚动事件
   *   cb: 回调
   * */
  touchmoveCheck: function ({
    id,
    RE = 50,
    dir,
    prevent,
    cb
  }) { // mobile整屏页面上下滚动检测（页面 <= 窗口）
    // 手机监听滑动事件
    let startX, startY, moveEndX, moveEndY, X, Y
    const $ = document.querySelector.bind(document)
    $('#' + id).addEventListener("touchstart", function (e) {
      // e.preventDefault();
      // console.log(`touchstart:`, e)
      e.stopPropagation()
      startX = e.changedTouches[0].pageX
      startY = e.changedTouches[0].pageY
      // console.log('touchstart:', startX, startY)
    })
    $('#' + id).addEventListener("touchmove", function (e) {
      // console.log(`touchmove:`, e)
      moveEndX = e.changedTouches[0].pageX
      moveEndY = e.changedTouches[0].pageY
      X = moveEndX - startX
      Y = moveEndY - startY
      console.log(X, Y)
      if (X > 0) {
        // console.log('left -> right')
      } else if (X < 0) {
        // console.log('right -> left')
      } else if (Y > 0) {
        // console.log('top -> bottom')
      } else if (Y < 0) {
        // console.log('bottom -> top')
      } else {
        console.log('just touch')
      }
      if (dir === 'x') {
        cb && cb(X > RE ? 'right' : X < -RE ? 'left' : 'stay', X)
      } else {
        cb && cb(Y > RE ? 'down' : Y < -RE ? 'up' : 'stay', Y) // windows滚轮一下是100单位
      }
      e.stopPropagation()
      prevent && e.preventDefault()
    })
  },
  /*
   * Facebook系列接口
   * this.$lib.FB.getUserInfo()
   * */
  FB: function () {
    return {
      /*
       * 获取用户信息
       * */
      getUserInfo: function (fn) {
        // 获取用户信息
        FB.api('/me?fields=id,name,picture,email', function (res) {
          fn && fn(res)
        })
      },
      /*
       * 登录脸书
       * */
      loginToFB: function (fn) {
        FB.login(function (res) {
          if (res.status === 'connected') {
            // FB.api('/me?fields=id,name,picture,email', function (data) {
            //   let response = {
            //     FBid: res.authResponse.userID,
            //     name: data.name,
            //     icon: data.picture.data.url,
            //     email: data.email
            //   }
            //   fn && fn(response)
            // })
            fn && fn(res)
          } else {
            fn && fn(res)
          }
        }, {
          scope: 'publish_actions,email'
        })
      },
      /*
       * 检查脸书登录状态（效果不佳）
       * */
      checkLogin: function (fn) {
        // console.log('checking login');
        FB.getLoginStatus(function (res) {
          // console.log('check done');
          fn && fn(res)
        })
      },
      statusChangeCallback: function (res) {
        if (res.status === 'connected') {
          // Logged into your app and Facebook.
        } else {
          // The person is not logged into your app or we are unable to tell.
          // console.log('Please log ' +'into this app.');
        }
      },
      /*
       * 脸书分享系列接口
       * */
      shareToFB: function (url, fn) { // 弃用
        console.log('feed')
        FB.ui({
          method: 'feed',
          // mobile_iframe: true,// 毫无用处
          link: url // 这里换成你的网址
        }, function (res) {
          fn && fn(res)
        })
      },
      shareToNewFB: function (url, fn) {
        console.log('share')
        FB.ui({
          method: 'share',
          href: url
        }, function (res) {
          fn && fn(res)
        })
      },
      FBSuperShare: function (url, fn) {
        console.log('share_open_graph')
        FB.ui({
          method: 'share_open_graph',
          action_type: 'og.likes',
          action_properties: JSON.stringify({
            object: url
          })
        }, function (res) {
          fn && fn(res)
        })
      },
      testAPI: function () {
        // console.log('Welcome!  Fetching your information.... ');
        FB.api('/me', function (res) {
          // console.log('Successful login for: ' + res.name);
          // console.log('Thanks for logging in, ' + res.name + '!');
        })
      },
      /*
       * 登出脸书
       * */
      logoutFB: function (fn) {
        FB.logout(function (res) {
          // user is now logged out
          // console.log(res);
          if (res) {
            // window.localStorage.clear();
            // delCookie('FBid');
            // delCookie('name');
            // delCookie('icon');
            // delCookie('email');
            fn && fn(res)
          }
        })
      }
    }
  }() // 脸书接口结束

}



// WEBPACK FOOTER //
// ./src/assets/lib/lib.js